import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import { ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import useChaseListNavigate from "../hooks/useChaseListNavigate";
import useFetchUserProfile from "../hooks/useFetchUserProfile";
import { setProfilePayload } from "../store/slices/profileSlice";
var HomeLayout = function (_a) {
    var children = _a.children;
    var isLoggedIn = useSelector(function (state) { return state.user.isLoggedIn; });
    var location = useLocation();
    var hash = location.hash;
    var chaseListNavigate = useChaseListNavigate();
    var ComponentToRender;
    var _b = useState(0), navValue = _b[0], setNavValue = _b[1];
    var _c = useState(""), seniority = _c[0], setSeniority = _c[1];
    var _d = useFetchUserProfile(), userProfile = _d.userProfile, profileApiResponse = _d.profileApiResponse, fetchUserProfile = _d.fetchUserProfile;
    var dispatch = useDispatch();
    useEffect(function () {
        // sync active tab from current hash
        // Do not override when Add Log tab (value=1) is active
        if (navValue === 1)
            return;
        if (hash && hash.includes('#/profile')) {
            setNavValue(2);
        }
        else if (hash && hash.includes('#/home')) {
            setNavValue(0);
        }
        else {
            // default or other route -> keep 0
            setNavValue(0);
        }
    }, [hash, navValue]);
    useEffect(function () {
        if (userProfile) {
            setSeniority(userProfile.seniority || "");
            if (profileApiResponse)
                dispatch(setProfilePayload(profileApiResponse));
            //  debugger;
        }
    }, [userProfile, isLoggedIn]);
    var exemptedPages = ["#/register", "#/login", "#/reset-pin"];
    if (!isLoggedIn || exemptedPages.includes(hash)) {
        return _jsx(_Fragment, { children: children });
    }
    var bottomTabStyle = {
        color: '#C9D0D8',
        position: 'relative',
        '&.Mui-selected': {
            color: '#00A190',
            '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                left: '20%',
                right: '20%',
                height: '4px',
                borderRadius: '4px',
                backgroundColor: '#00A190'
            }
        }
    };
    return (_jsxs("div", { className: "flex flex-col h-screen restricted_container", children: [_jsx(ToastContainer, {}), _jsx(Navbar, {}), _jsx("main", { children: children }), _jsx(Paper, { sx: { position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }, elevation: 3, children: _jsxs(BottomNavigation, { showLabels: true, value: navValue, onChange: function (event, newValue) {
                        setNavValue(newValue);
                        if (newValue === 0) {
                            chaseListNavigate("#/home");
                        }
                        else if (newValue === 1) {
                            // Navigate to home first, then trigger Add Log modal in TimeLogs
                            var openAddLog = function () {
                                try {
                                    window.dispatchEvent(new Event('open-add-log'));
                                }
                                catch (e) {
                                    // ignore if window not available
                                }
                            };
                            if (hash && hash.includes('#/home')) {
                                // already on home — open immediately
                                openAddLog();
                            }
                            else {
                                // navigate to home first, then open after a short delay
                                chaseListNavigate("#/home");
                                setTimeout(openAddLog, 300);
                            }
                        }
                        else if (newValue === 2) {
                            chaseListNavigate("#/profile");
                        }
                    }, children: [_jsx(BottomNavigationAction
                        //   label="Home"
                        , { 
                            //   label="Home"
                            value: 0, icon: _jsx(HomeOutlinedIcon, {}), sx: bottomTabStyle }), (_jsx(BottomNavigationAction
                        //   label="Second"
                        , { 
                            //   label="Second"
                            value: 1, icon: _jsx(LocalHospitalIcon, {}), sx: bottomTabStyle })), _jsx(BottomNavigationAction
                        //   label="Profile"
                        , { 
                            //   label="Profile"
                            value: 2, icon: _jsx(AccountCircleOutlinedIcon, {}), sx: bottomTabStyle })] }) })] }));
};
export default HomeLayout;
